



























import { defineComponent } from '@vue/composition-api';

const Error = defineComponent({
  // setup() {},
});

export default Error;
